import links from '../../links';

export default {
  title: `Les CGU ont changé, merci de les lire et les valider`,
  text: `J’ai lu et j'accepte sans réserve les [CGU](${links.legalTerms})`,
  error: `Veuillez accepter nos CGU`,
  confirm: `Valider`,
};
